import { render, staticRenderFns } from "./BomForwardDeployCarOptionType.vue?vue&type=template&id=28dc5ef2&"
import script from "./BomForwardDeployCarOptionType.vue?vue&type=script&lang=js&"
export * from "./BomForwardDeployCarOptionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports